import React, { Component } from 'react';
import { getPropertyValue, deflateModelVariables } from '../../../../util';
import classNames from 'classnames';
import { PropTypes } from 'prop-types';

const VariableAuthor = {
  0: 'User',
  1: 'Constraint',
  2: 'Procedure',
  3: 'Default',
  4: 'Environment',
  5: 'None'
};

const VariableType = {
  0: 'String',
  1: 'Bool',
  2: 'Int',
  3: 'Float',
  4: 'DateTime',
  5: 'Unit',
  6: 'CustomType'
};

export class ModelDebugViewer extends Component {
  constructor() {
    super();
    this.state = {
      viewableStates: {
        0: { title: 'UserAssigned', checked: true, value: 1 },
        1: { title: 'DefaultAssigned', checked: true, value: 2 }
      },
      sortedBy: {
        column: 'fqn',
        descending: false
      },
      expandedRow: '',
      filter: ''
    };
  }
  updateViewableState( targetState ) {
    this.setState( {
      viewableStates: {
        ...this.state.viewableStates,
        [targetState]: {...this.state.viewableStates[targetState], checked: !this.state.viewableStates[targetState].checked }
      }
    } );
  }
  updateSortedBy( column ) {
    this.setState( {
      sortedBy: {
        column: column,
        descending: this.state.sortedBy.column === column ? !this.state.sortedBy.descending : false
      }
    } );
  }
  updateFilter( filter ) {
    if ( filter === this.state.filter ) {
      return;
    }  
    this.setState( {
      filter: filter.toLowerCase()
    } );
  }
  updateExpandedRow( expandedRow ) {
    this.setState( {
      expandedRow: this.state.expandedRow === expandedRow ? '' : expandedRow
    } );
  }
  render() {
    let { model } = this.props;
    if ( !model ) {
      return null;
    }
    let { sortedBy, viewableStates, filter, expandedRow } = this.state;
    let isSortedBy = ( ( sortedBy ) => column => sortedBy.column === column )( sortedBy );
    let isDescending = ( ( sortedBy ) => column => isSortedBy( column ) && sortedBy.descending )( sortedBy );
    let showStatesOf = Object.values ( viewableStates ).where( value => value.checked ).select( v => parseInt( v.value ) );
    let variables = deflateModelVariables( model )
      .where( variable => variable.assignedValue && showStatesOf.indexOf( variable.assignedValue.state ) !== -1 )
      .select( v => ( { fqn: `${v.group}.${v.name}`, ...v } ) );
    if ( filter ) {
      // search for either name or the assignedValue
      variables = variables.where( v => v.fqn.toLowerCase().indexOf( filter ) !== -1 || v.assignedValue && v.assignedValue.name.toLowerCase().indexOf( filter ) !== -1 ).select();
    }
    let colSize = parseInt( 12.0 / ( Object.keys( viewableStates ).length + 1 ) );
    return (
      <div className="col-12 grid-table">
        <div className="row status-bar">
          { Object.values( viewableStates ).map( ( value, key ) => <div key={ value.title } className={ `col-${colSize}` }><input type="checkbox" onChange={ () => this.updateViewableState( key ) } checked={ value.checked } />{ value.title }</div> ) }
          <div className={ `col-${colSize}` }><input type="text" className="filter" placeholder="Search for specific value" defaultValue={ filter } onBlur={ ( e ) => this.updateFilter( e.target.value ) } onKeyDown={ ( e ) => e.keyCode === 13 && this.updateFilter( e.target.value ) } /></div>
        </div>
        <div className="row grid-header">
          <div onClick={ () => this.updateSortedBy( 'fqn' ) } className={ classNames( 'col-5 ellipsed', { 'sorted': isSortedBy( 'fqn' ), 'descending': isDescending( 'fqn' ) } ) }>Fqn</div>
          <div onClick={ () => this.updateSortedBy( 'type' ) } className={ classNames( 'col-2 ellipsed', { 'sorted': isSortedBy( 'type' ), 'descending': isDescending( 'type' ) } ) }>Type</div>
          <div onClick={ () => this.updateSortedBy( 'assignedValue.value' ) } className={ classNames( 'col-2 ellipsed', { 'sorted': isSortedBy( 'assignedValue.value' ), 'descending': isDescending( 'assignedValue.value' ) } ) }>Value</div>
          <div onClick={ () => this.updateSortedBy( 'assignedValue.state' ) } className={ classNames( 'col-2 ellipsed', { 'sorted': isSortedBy( 'assignedValue.state' ), 'descending': isDescending( 'assignedValue.state' ) } ) }>State</div>
          <div onClick={ () => this.updateSortedBy( 'author' ) } className={ classNames( 'col-1 ellipsed', { 'sorted': isSortedBy( 'author' ), 'descending': isDescending( 'author' ) } ) }>Author</div>
        </div>
        { variables.orderBy( getPropertyValue( sortedBy.column ) ).descending( sortedBy.descending ) .map( ( v, k ) => {
          return [
            <div className={ `row row-${k % 2}` } key={ `dbg-viewer-${v.fqn}}` } onClick={ () => this.updateExpandedRow( v.fqn ) }>
              <div className="col-5 ellipsed">{ v.fqn }</div>
              <div className="col-2 ellipsed">{ v.type !== 6 ? VariableType[v.type] : v.typeName }</div>
              <div className="col-2 ellipsed">{ v.assignedValue.name }</div>
              <div className="col-2 ellipsed">{ Object.values( viewableStates ).first( value => value.value === v.assignedValue.state ).title }</div>
              <div className="col-1 ellipsed">{ VariableAuthor[v.author] }</div>
            </div>,
            expandedRow === v.fqn && <div className={ `row-detail-${k % 2}` } key={ `dbg-viewer-detail-${v.fqn}}` } onClick={ () => this.updateExpandedRow( v.fqn ) }>
              { v.properties && Object.keys( v.properties ).map( propertyKey => <div className="row" key={ `property-detail-${v.fqn}-${propertyKey}` }>
                <div className="col-5 label">{ propertyKey }</div>
                <div className="col-7 value">{ v.properties[propertyKey].toString() }</div></div> ) }
            </div>
          ];
        } ) }
      </div> );
  }
}

ModelDebugViewer.propTypes = {
  model: PropTypes.shape( {} )
};